export const customSelectStyles = {
  control: (provided) => ({
    ...provided,
    minHeight: 38,
    borderRadius: 0,
    maxHeight: '40px',
    height: '40px',
    borderColor: '#D9EAEC',
    color: 'red',
  }),
  input: (provided) => ({
    ...provided,
    height: '100%',
    margin: 0,
    padding: 0,
    color: 'green',
  }),
  indicatorSeparator: () => ({
    display: 'none',
    color: 'blue',
  }),
  indicatorsContainer: (provided) => ({
    ...provided,
    height: '40px',
  }),
  singleValue: (provided) => ({
    ...provided,
    fontWeight: 'normal',
    cursor: 'pointer',
    transform: 'none',
    border: 'none',
    top: '0',
    height: '40px',
    lineHeight: '40px',
  }),
  valueContainer: (provided) => ({
    ...provided,
    height: '40px',
    color: 'red',
  }),
  placeholder: (base) => ({
    ...base,
    display: 'none',
    color: 'red',
  }),
};

export const newEcommerceStyles = {
  control: (provided, props) => {
    const styles = {
      ...provided,

      minHeight: 38,

      borderRadius: 0,

      maxHeight: '40px',

      height: '40px',
    };
    if (props?.isDisabled) {
      styles.backgroundColor = 'rgba(239, 239, 239, 0.3)';
      styles.borderColor = 'rgba(239, 239, 239, 0.3)';
    }
    return styles;
  },

  input: (provided) => ({
    ...provided,

    height: '100%',

    margin: 0,

    padding: 0,

    color: 'black',
  }),

  indicatorSeparator: () => ({
    display: 'none',
  }),

  indicatorsContainer: (provided) => ({
    ...provided,

    height: '40px',
  }),

  singleValue: (provided: any) => ({
    ...provided,

    fontWeight: 'normal',

    cursor: 'pointer',

    transform: 'none',

    border: 'none',

    top: '0',

    height: '40px',

    lineHeight: '40px',

    color: 'black',
  }),

  valueContainer: (provided) => ({
    ...provided,

    height: '40px',
  }),

  placeholder: (base) => ({
    ...base,
  }),

  option: (provided) => ({
    ...provided,

    color: 'black',
  }),
};

export const ecommerceDefaultColorBlackSelect = {
  input: (provided) => ({
    ...provided,
    color: 'black',
  }),

  indicatorSeparator: () => ({
    display: 'none',
  }),

  indicatorsContainer: (provided) => ({
    ...provided,
    height: '40px',
  }),

  singleValue: (provided: any) => ({
    ...provided,
    color: 'black',
  }),

  valueContainer: (provided) => ({
    ...provided,
    height: '40px',
  }),

  placeholder: (base) => ({
    ...base,
  }),

  option: (provided) => ({
    ...provided,
    color: 'black',
  }),
};

export const calculateMobileHeight = () => {
  const vh = window.innerHeight * 0.01;
  document.documentElement.style.setProperty('--vh', `${vh}px`);
};
